// Datos de todos los productos de ProBwa - Distributeur REBO Bamboo
// Imágenes actualizadas con fotos reales

export const products = [
  // TERRASSES - Lado liso
  {
    id: 1,
    slug: "lames-terrasse-tropic-miel",
    category: "terrasse",
    categoryLabel: "Cailleboti, terrasses (Deck)",
    name: "Lames de terrasse - Tropic Miel",
    dimensions: "20mm × 140mm × 2500mm",
    shortDescription: "Lames de terrasses REBO en bambou tressé carbonisé, idéales pour le milieu tropical.",
    description: `Nos lames de terrasses REBO en bambou tressé carbonisé sont idéales pour le milieu tropical exigeant de la Réunion. Sa densité extrême obtenue par la compression des brins de bambou et leur carbonisation à 160°C en fait un produit d'une densité égale à l'ipé, le bois dur le plus résistant (1200kg/m3).

Avec nos fixations par clip Inox A4 sur les côtés de la lame et un aboutage rainure/languette, il en résulte une terrasse qui ne bouge pas dans le temps, des lames droites et espacées parfaitement.

Sans vis apparentes, vous obtiendrez une terrasse élégante sans les défauts des poses à vis (fentes dans le bois, échardes, taches noires autour des trous des vis, vis non alignées).

Produit certifié REBO Bamboo - Durabilité Classe 1 (EN350), Classe d'utilisation 4 (EN335).`,
    image: "https://customer-assets.emergentagent.com/job_44e06a86-26a6-4a1c-a1e6-5ebd3ec28cc3/artifacts/jj3x8hy8_Gemini_Generated_Image_xql3a6xql3a6xql3.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_44e06a86-26a6-4a1c-a1e6-5ebd3ec28cc3/artifacts/jj3x8hy8_Gemini_Generated_Image_xql3a6xql3a6xql3.png",
      "https://customer-assets.emergentagent.com/job_44e06a86-26a6-4a1c-a1e6-5ebd3ec28cc3/artifacts/ne4g06k1_MIEL2.png",
    ],
    features: ["Densité 1200kg/m³", "Carbonisation 160°C", "Clips Inox A4", "Sans vis apparentes", "Surface lisse"],
  },
  {
    id: 2,
    slug: "lames-terrasse-tropic-teck",
    category: "terrasse",
    categoryLabel: "Cailleboti, terrasses (Deck)",
    name: "Lames de terrasse - Tropic Teck",
    dimensions: "20mm × 140mm × 2500mm",
    shortDescription: "Lames de terrasses REBO en bambou tressé carbonisé avec finition teck.",
    description: `Nos lames de terrasses REBO en bambou tressé carbonisé sont idéales pour le milieu tropical exigeant de la Réunion. Sa densité extrême obtenue par la compression des brins de bambou et leur carbonisation à 160°C en fait un produit d'une densité égale à l'ipé, le bois dur le plus résistant (1200kg/m3).

Avec nos fixations par clip Inox A4 sur les côtés de la lame et un aboutage rainure/languette, il en résulte une terrasse qui ne bouge pas dans le temps, des lames droites et espacées parfaitement.

Sans vis apparentes, vous obtiendrez une terrasse élégante sans les défauts des poses à vis.

Produit certifié REBO Bamboo - Durabilité Classe 1 (EN350), Classe d'utilisation 4 (EN335).`,
    image: "https://customer-assets.emergentagent.com/job_44e06a86-26a6-4a1c-a1e6-5ebd3ec28cc3/artifacts/107zhnt9_Gemini_Generated_Image_lx0ug2lx0ug2lx0u.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_44e06a86-26a6-4a1c-a1e6-5ebd3ec28cc3/artifacts/107zhnt9_Gemini_Generated_Image_lx0ug2lx0ug2lx0u.png",
    ],
    features: ["Densité 1200kg/m³", "Carbonisation 160°C", "Clips Inox A4", "Finition Teck", "Surface lisse"],
  },
  {
    id: 3,
    slug: "lames-terrasse-tropic-intense",
    category: "terrasse",
    categoryLabel: "Cailleboti, terrasses (Deck)",
    name: "Lames de terrasse - Tropic Intense",
    dimensions: "20mm × 140mm × 2000mm",
    shortDescription: "Lames REBO carbonisées à 200°C pour les milieux les plus extrêmes.",
    description: `Nos lames de terrasses REBO en bambou tressé carbonisé INTENSES sont idéales pour le milieu tropical exigeant de l'île INTENSE.

Pour les applications dans les milieux les plus extrêmes, les restaurants, bars, les endroits les plus humides ou en milieu salin, nos lames de terrasses carbonisées à 200°C rendent le bambou encore plus résistant.

Sa carbonisation plus haute lui donne sa couleur ébène avec des variations de couleur de fibres qui peuvent rappeler les veinages de l'ipé ou du tiger wood.

Produit certifié REBO Bamboo - Durabilité Classe 1 (EN350), Antidérapage R10.`,
    image: "https://customer-assets.emergentagent.com/job_44e06a86-26a6-4a1c-a1e6-5ebd3ec28cc3/artifacts/udn6uc0r_INTENSE%202.png",
    gallery: [
      "https://customer-assets.emergentagent.com/job_44e06a86-26a6-4a1c-a1e6-5ebd3ec28cc3/artifacts/udn6uc0r_INTENSE%202.png",
    ],
    features: ["Carbonisation 200°C", "Résistance extrême", "Milieu salin", "Couleur ébène", "Surface lisse"],
  },
  // TASSEAUX
  {
    id: 4,
    slug: "tasseaux-bambou",
    category: "tasseaux",
    categoryLabel: "Tasseaux",
    name: "Tasseaux en bambou",
    dimensions: "60mm×40mm×2500mm / 40mm×40mm×2500mm",
    shortDescription: "Tasseaux polyvalents pour structures et décorations.",
    description: `Nos tasseaux en bambou de 60×40 ou 40×40 de longueurs 2.50m servent à réaliser des structures de cailleboti et deck mais aussi à créer des ensembles décoratifs tels que des séparations de pièces, des panneaux muraux, des faux plafonds de varangues ou de pergolas, des brises vues ou brises soleil.

Ils peuvent être poncés, peints, huilés ou saturés pour leur donner la couleur voulue. Très résistants, ils ne se déforment pas comme les produits en bois tendres (Pin, épicéa, cryptoméria) et n'ont pas d'exsudation de résine et sont moins coûteux et plus respectueux de nos forêts que les bois exotiques.`,
    image: "https://customer-assets.emergentagent.com/job_44e06a86-26a6-4a1c-a1e6-5ebd3ec28cc3/artifacts/ollwr5zb_Tasseau%2040%20-%2040-%202500.jpg",
    gallery: [],
    features: ["Personnalisable", "Sans déformation", "Sans résine", "Éco-responsable"],
  },
  // PARQUETS
  {
    id: 5,
    slug: "plancher-interieur-bambou",
    category: "parquet",
    categoryLabel: "Parquets",
    name: "Plancher intérieur en bambou tressé carbonisé",
    dimensions: "14mm × 125mm × 915mm",
    shortDescription: "Revêtement de sol très dur et durable, véritablement «vert».",
    description: `Le bambou est un matériau de revêtement de sol très dur et durable, et c'est un matériau de construction véritablement «vert». Le bambou et le bois dur ont un aspect et une sensation similaires. Cependant, le bambou n'est pas un bois, mais une herbe ligneuse, qui a une période de croissance très rapide dans le monde.

Les planchers en bambou tissé "Strand" sont faits de brins de bambou compressés sous une chaleur et une pression extrêmes, ce qui fusionne les matériaux et crée des planchers plus durs et plus résistants que les bois durs traditionnels.

Le bambou tissé à brins a rarement besoin d'être remis en état dans les environnements résidentiels, ce qui en fait une option de revêtement de sol avec un très bon rapport qualité-durabilité/prix.`,
    image: "https://customer-assets.emergentagent.com/job_44e06a86-26a6-4a1c-a1e6-5ebd3ec28cc3/artifacts/e89a03t0_parquet%20pose.jpg",
    gallery: [],
    features: ["Plus dur que le bois", "Faible entretien", "Excellent rapport qualité/prix", "100% écologique"],
  },
  // BARDAGE
  {
    id: 7,
    slug: "bardage-bambou",
    category: "bardage",
    categoryLabel: "Bardage",
    name: "Bardage REBO en bambou tressé carbonisé",
    dimensions: "18mm × 140mm × 1850mm",
    shortDescription: "Bardage REBO extérieur et intérieur en bambou tressé, élégant et durable.",
    description: `Le bardage REBO en bambou tressé carbonisé est la solution idéale pour habiller vos façades extérieures et intérieures avec un matériau naturel et écologique.

Grâce à sa densité exceptionnelle et son processus de carbonisation, le bardage en bambou résiste aux intempéries et conserve sa beauté au fil du temps. Son aspect moderne et chaleureux apporte une touche d'élégance à tout type de construction.

Facile à poser grâce au système de clips en acier inoxydable, le bardage en bambou ProBwa est une alternative durable et responsable aux bardages traditionnels en bois exotique.

Produit certifié REBO Bamboo - Durabilité Classe 1 (EN350), Ignifuge (EN 13501-1).`,
    image: "https://customer-assets.emergentagent.com/job_44e06a86-26a6-4a1c-a1e6-5ebd3ec28cc3/artifacts/mlx82aux_Gemini_Generated_Image_9y69109y69109y69.png",
    gallery: [],
    features: ["Densité 1200kg/m³", "Résistant aux intempéries", "Clips Inox A4", "Pose facile", "Écologique"],
  },
];

// Certifications
export const certifications = [
  {
    id: 1,
    name: "ÉMISSION DE FORMALDÉHYDE",
    description: "Conformément à EN 13986:2004+A1:2015 par SGS",
    icon: "formaldehyde",
  },
  {
    id: 2,
    name: "RÉSISTANCE",
    description: "Résistance au courbage conformément à 408:2012 (moyenne) 87N/mm² par EPH laboratoire. Modules élastiques de courbage conformément à EN408:2012 (moyenne) 18700 N/mm² par EPH laboratoire",
    icon: "resistance",
  },
  {
    id: 3,
    name: "IGNIFUGE",
    description: "Conformément à EN 13501-1 par EPH laboratoire",
    icon: "fire",
  },
  {
    id: 4,
    name: "HAUTE DURETÉ",
    description: "Densité 1,2g/cm³. Dureté de Brinell conformément à EN 1534:2011 107N/mm²",
    icon: "hardness",
  },
  {
    id: 5,
    name: "DURABILITÉ",
    description: "Les produits de série M&D avec la durabilité de classe 1 (EN350) testés suivant ENV 12038/ENV807 par Rise Bioeconomie.",
    icon: "durability",
  },
  {
    id: 6,
    name: "CLASSE D'UTILISATION",
    description: "Les produits de série M&D avec la durabilité de classe 4 d'utilisation (EN335) testés suivant ENV 12038/ENV 807 par RISE Bioeconomie.",
    icon: "class",
  },
  {
    id: 7,
    name: "ANTIDÉRAPAGE",
    description: "Les produits de série M&D antidérapages R10 (Essai de pente humide d'huile) conformément à DIN51130:2014.",
    icon: "antislip",
  },
  {
    id: 8,
    name: "VERT",
    description: "Période de croissance de 5 ans. Ressources infinies. Amical à l'environnement.",
    icon: "green",
  },
];

// Informations de contact
export const contactInfo = {
  email: "probwalareunion@gmail.com",
  phone: "0692 50 26 85",
  location: "La Réunion",
};

export const getProductBySlug = (slug) => {
  return products.find((p) => p.slug === slug);
};

export const getProductsByCategory = (category) => {
  return products.filter((p) => p.category === category);
};
